import { css } from 'styled-components';
import { Device, from } from './media';
export const SitePadding = 20;
export const SiteWidth = 1240;
export const siteWide = css `
  margin: 0 auto;
  max-width: var(--siteWidth);
  padding: 0 var(--sitePadding);
  width: 100%;
`;
export const baseGrid = css `
  display: grid;
  column-gap: var(--gutterWidth);
  grid-template-columns: repeat(4, 1fr);

  @media ${from(Device.Tablet)} {
    grid-template-columns: repeat(8, 1fr);
  }

  @media ${from(Device.Desktop)} {
    grid-template-columns: repeat(12, 1fr);
  }
`;
